export const roomCapabilityCopy = {
  en: {
    title: "Room options", reviewed: "I have reviewed the options available in this room",
    unknown: "Options have not been reviewed yet.",
    included: "All selected options are included in the room's existing hourly and peak rates. Customers book the whole room.",
    activities: "Included activities", amenities: "Included amenities",
    console: "Console gaming", pc: "PC gaming", vr: "VR", simulator: "Racing simulator", cinema: "Cinema",
    screen: "Screen", netflix: "Netflix available",
  },
  ar: {
    title: "اختيارات الغرفة", reviewed: "راجعت الاختيارات المتاحة في الغرفة دي",
    unknown: "اختيارات الغرفة لسه ما اتراجعتش.",
    included: "كل الاختيارات المحددة ضمن سعر الغرفة الحالي وسعر أوقات الذروة. الحجز للغرفة كلها.",
    activities: "الأنشطة المشمولة", amenities: "المرافق المشمولة",
    console: "ألعاب كونسول", pc: "ألعاب كمبيوتر", vr: "واقع افتراضي", simulator: "محاكي سباق", cinema: "سينما",
    screen: "شاشة", netflix: "Netflix متاح",
  },
} as const;
